"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import type { CreateProxyAllocateRepAction } from "@/entities/IProxy";
import { ApiProfileProxyActionType } from "@/generated/models/ApiProfileProxyActionType";
import CommonInput from "@/components/utils/input/CommonInput";
import CircleLoader, { CircleLoaderSize } from "@/components/distribution-plan-tool/common/CircleLoader";
export default function ProxyCreateActionConfigAllocateRep(t0) {
  const $ = _c(32);
  const {
    endTime,
    submitting,
    onSubmit,
    onCancel
  } = t0;
  const [creditAmount, setCreditAmount] = useState(0);
  let t1;
  if ($[0] !== creditAmount || $[1] !== endTime || $[2] !== onSubmit) {
    t1 = () => onSubmit({
      action_type: ApiProfileProxyActionType.AllocateRep,
      end_time: endTime,
      credit_amount: creditAmount
    });
    $[0] = creditAmount;
    $[1] = endTime;
    $[2] = onSubmit;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleSubmit = t1;
  const [disabled, setDisabled] = useState(true);
  let t2;
  let t3;
  if ($[4] !== creditAmount) {
    t2 = () => setDisabled(creditAmount <= 0);
    t3 = [creditAmount];
    $[4] = creditAmount;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="tw-block tw-text-sm tw-font-medium tw-leading-5 tw-text-iron-300">Credit Amount</span>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== creditAmount) {
    t5 = creditAmount.toString();
    $[8] = creditAmount;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = newV => setCreditAmount(parseInt(newV ?? "0"));
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5) {
    t7 = <div>{t4}<div className="tw-mt-1.5 tw-w-full md:tw-w-40"><CommonInput value={t5} inputType="number" onChange={t6} placeholder="Credit Amount" theme="light" /></div></div>;
    $[11] = t5;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== onCancel || $[14] !== submitting) {
    t8 = <button type="button" disabled={submitting} onClick={onCancel} className="tw-w-full sm:tw-w-auto tw-flex tw-items-center tw-justify-center tw-relative tw-bg-iron-800 tw-px-3.5 tw-py-2.5 tw-text-sm tw-leading-5 tw-font-semibold tw-text-iron-300 tw-border tw-border-solid tw-border-iron-700 tw-rounded-lg hover:tw-bg-iron-700 tw-transition tw-duration-300 tw-ease-out">Cancel</button>;
    $[13] = onCancel;
    $[14] = submitting;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = disabled || submitting;
  const t10 = `${disabled ? "tw-opacity-50" : "hover:tw-bg-primary-600 hover:tw-border-primary-600"} tw-w-full sm:tw-w-auto tw-bg-primary-500 tw-px-3.5 tw-py-2.5 tw-text-sm tw-leading-5 tw-font-semibold tw-text-white tw-border tw-border-solid tw-border-primary-500 tw-rounded-lg tw-transition tw-duration-300 tw-ease-out`;
  let t11;
  if ($[16] !== submitting) {
    t11 = submitting && <CircleLoader size={CircleLoaderSize.SMALL} />;
    $[16] = submitting;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <span>Save</span>;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t11) {
    t13 = <div className="tw-flex tw-items-center tw-justify-center tw-space-x-2">{t11}{t12}</div>;
    $[19] = t11;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== handleSubmit || $[22] !== t10 || $[23] !== t13 || $[24] !== t9) {
    t14 = <button type="button" disabled={t9} onClick={handleSubmit} className={t10}>{t13}</button>;
    $[21] = handleSubmit;
    $[22] = t10;
    $[23] = t13;
    $[24] = t9;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t14 || $[27] !== t8) {
    t15 = <div className="tw-mt-5 md:tw-mt-0 tw-flex tw-items-center tw-justify-end md:tw-justify-start tw-gap-x-3">{t8}{t14}</div>;
    $[26] = t14;
    $[27] = t8;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t15 || $[30] !== t7) {
    t16 = <div className="md:tw-flex md:tw-items-end tw-gap-x-3">{t7}{t15}</div>;
    $[29] = t15;
    $[30] = t7;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  return t16;
}